import { Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import { validateEmptyFields } from '../../helpers/util'
import BackButton from 'components/BackButton'
import InputTextFieldGrid from 'components/common/InputTextFieldGrid'
import InputSelectFieldGrid from 'components/common/InputSelectFieldGrid'
import CustomButton from 'components/CustomButton'

// Descuento con el que el proveedor acredita los abonos: lo que entra al saldo es mas
// de lo que se le pago. Es un porcentaje, no un factor, y vacio es valido: esa
// instancia no tiene descuento pactado.
const descuentoAbonoValido = (value) => {
  const raw = value === undefined || value === null ? '' : String(value).trim();
  if (raw === '') return true;
  if (!/^\d+(\.\d{1,2})?$/.test(raw)) return 'Escribe un porcentaje con hasta dos decimales';
  if (Number(raw) > 100) return 'El descuento no puede ser mayor que 100';
  return true;
};

// Se guarda como numero, o null si se dejo vacio, para que nadie tenga que adivinar
// si "" significa cero.
const descuentoAbono = (value) => {
  const raw = value === undefined || value === null ? '' : String(value).trim();
  return raw === '' ? null : Number(raw);
};

const CredsProviderForm = ({ title, goBack, defaultValues, submit, validate }) => {
  const { control, handleSubmit } = useForm({ defaultValues });
  const watch = useWatch({ control });
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    setDisabled(validateEmptyFields(watch, { validate, skip_fields: ['backup_time', 'abono_discount'] }));
    // eslint-disable-next-line
  }, [watch]);

  return (
    <>
      <BackButton name={title} click={goBack} />
      <Grid container direction="column" justifyContent="center" alignItems="center" >
        <Grid container direction="column" m={"40px"} maxWidth={"40%"} justifyContent="center" alignItems="center" spacing={3}>
          <InputTextFieldGrid
            name="name_connector"
            label="Nombre descriptivo"
            required="Debes agregar el nombre descriptivo"
            control={control}
          />
          <InputTextFieldGrid
            name="client_id"
            label="Client Id"
            required="Debes agregar el client id"
            control={control}
          />
          <InputTextFieldGrid
            name="user_name"
            label="Nombre de Usuario"
            required="Debes agregar el nombre de usuario"
            control={control}
          />
          <InputTextFieldGrid
            name="password_digest"
            label="Contraseña"
            required="Debes agregar la contraseña"
            inputType={"password"}
            control={control}
          />
          <InputTextFieldGrid
            name="backup_time"
            label="Tiempo de respaldo (segundos)"
            inputType={"number"}
            control={control}
          />
          <InputTextFieldGrid
            name="abono_discount"
            label="Descuento de abono (%)"
            inputType={"number"}
            step={"0.01"}
            control={control}
            rules={{ validate: descuentoAbonoValido }}
          />
          <InputSelectFieldGrid
            name="active"
            label="Disponible"
            required="Debes seleccionar si requiere conciliación"
            control={control}
            data={[
              { id: 1, name: 'Activa' },
              { id: 2, name: 'Inactiva' }
            ]}
          />
          <InputSelectFieldGrid
            name="conciliacion"
            label="Conciliación"
            required="Debes seleccionar si requiere conciliación"
            control={control}
            data={[
              { id: 1, name: 'Activa' },
              { id: 2, name: 'Inactiva' }
            ]}
          />
        </Grid>
        <Grid item justifyContent="center" alignItems="center" >
          <CustomButton
            click={handleSubmit((data) => submit({ ...data, abono_discount: descuentoAbono(data.abono_discount) }))}
            name={"Guardar"}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default CredsProviderForm